import {
  React,
  Component,
  withCookies,
  withRouter,
} from 'imports/CommonImports';

import {
  TextField,
} from 'material-ui';

import {
  PrimaryColor1,
} from 'imports/DesignImports';

import {
  FilterOptionSelect,
  IndicatorField,
  FileField,
} from 'imports/ComponentsImports';


const styles = {
  latoFont: {
    fontFamily: 'Lato',
    fontWeight: '300',
    color: PrimaryColor1,
  },
  finishSectionContainer: {
    display: 'flex',
    justifyContent: 'center',
    margin: '2em 0',
  },
  textArea: {
    overflow: 'scroll',
    fontWeight: '300',
    color: PrimaryColor1,
  },
  underline: {
    width: '50%',
    color: PrimaryColor1,
  },
  floatingLabel: {
    color: PrimaryColor1,
  },
}

class ProjectInformation extends Component {
  constructor(props){
    super(props);
    this.state = {
      id: props.project.id,
      name: props.project.information.name,
      leaderName: props.project.information.leader_first_name + ' ' +  props.project.information.leader_last_name,
      sponsorName:  props.project.information.sponsor_first_name + ' ' +  props.project.information.sponsor_last_name,
      leaderEmail: props.project.information.leader_email,
      area: props.project.information.area.name,
      year: (new Date(props.project.information.start_date)).getFullYear(),
      solutionType: props.project.options.filter(option => option.filter_id === 1).map(option => option.option.name),
      novelty: props.project.options.find(option => option.filter_id === 11).option.name,
      benefitType: props.project.options.filter(option => option.filter_id === 21).map(option => option.option.name),
      problem: props.project.information.problem,
      solution: props.project.information.solution,
      objectives: props.project.information.objectives,
      characteristics: props.project.information.characteristics,
      benefits: props.project.information.benefits,
      methodStatus: null,
      calculationStatus: null,
      user: this.props.cookies.get('user'),
    }
  }

  componentWillReceiveProps(props) {
    this.setState({
      id: props.project.id,
      name: props.project.information.name,
      leaderName: props.project.information.leader_first_name + props.project.information.leader_last_name,
      sponsorName:  props.project.information.sponsor_first_name + props.project.information.sponsor_last_name,
      leaderEmail: props.project.information.leader_email,
      area: props.project.information.area.name,
      year: (new Date(props.project.information.start_date)).getFullYear(),
      solutionType: props.project.options.filter(option => option.filter_id === 1).map(option => option.option.name),
      novelty: props.project.options.find(option => option.filter_id === 11).option.name,
      benefitType: props.project.options.filter(option => option.filter_id === 21).map(option => option.option.name),
      problem: props.project.information.problem,
      solution: props.project.information.solution,
      objectives: props.project.information.objectives,
      characteristics: props.project.information.characteristics,
      benefits: props.project.information.benefits,
      user: props.cookies.get('user'),
    })
  }

  render() {
    let isFinished = false;
    console.log(this.props);
    this.props.signatures.forEach(signature => {
      if((signature.user_position === 'Líder de proyecto' && signature.decision === 'signed')) {
        isFinished = true;
      }
    });
    // this.props.project.state.forEach(state => {
    //   if(state.state === "En proceso de firma") {
    //     isFinished = true;
    //   }
    // });
    return(
      <div style={{margin:'1em 2em'}}>
        <h2>1. Información del proyecto</h2>
        <h3>1.1 Información general</h3>
        <div style={{ display: 'flex', flexWrap: 'wrap'}}>
          <TextField
            inputStyle={styles.latoFont}
            disabled={true}
            defaultValue={this.state.name}
            floatingLabelText="Nombre"
            floatingLabelFixed={true}
            floatingLabelStyle={styles.floatingLabel}
            style={{width:'50%'}}
            underlineStyle={styles.underline}
          />
          <TextField
            inputStyle={styles.latoFont}
            disabled={true}
            defaultValue={this.state.leaderName}
            floatingLabelText="Lider"
            floatingLabelFixed={true}
            floatingLabelStyle={styles.floatingLabel}
            style={{width:'50%'}}
            underlineStyle={styles.underline}
          />
          <TextField
            inputStyle={styles.latoFont}
            disabled={true}
            defaultValue={this.state.leaderEmail}
            floatingLabelText="Email líder"
            floatingLabelFixed={true}
            floatingLabelStyle={styles.floatingLabel}
            style={{width:'50%'}}
            underlineStyle={styles.underline}
          />
          <TextField
            inputStyle={styles.latoFont}
            disabled={true}
            defaultValue={this.state.sponsorName}
            floatingLabelText="Sponsor"
            floatingLabelFixed={true}
            floatingLabelStyle={styles.floatingLabel}
            style={{width:'50%'}}
            underlineStyle={styles.underline}
          />
          <TextField
            inputStyle={styles.latoFont}
            disabled={true}
            defaultValue={this.state.area}
            floatingLabelText="Área"
            floatingLabelFixed={true}
            floatingLabelStyle={styles.floatingLabel}
            style={{width:'50%'}}
            underlineStyle={styles.underline}
          />
          <TextField
            inputStyle={styles.latoFont}
            disabled={true}
            defaultValue={this.state.year}
            floatingLabelText="Año de implementación"
            floatingLabelFixed={true}
            floatingLabelStyle={styles.floatingLabel}
            style={{width:'50%'}}
            underlineStyle={styles.underline}
          />
        </div>

        <div style={{borderTop: '2px solid #8c92a1', marginTop: '2em'}}>
          <h3>1.2 Características</h3>
          <FilterOptionSelect solutionType={this.state.solutionType} novelty={this.state.novelty} benefitType={this.state.benefitType} />
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', borderTop: '2px solid #8c92a1', marginTop: '2em', padding: '1em'}}>
          <h3>1.3 Solución y beneficios</h3>
          <TextField
            underlineStyle={styles.underline}
            floatingLabelStyle={styles.floatingLabel}
            textareaStyle={styles.textArea}
            inputStyle={{...styles.latoFont, ...{marginLeft: '1em'}}}
            defaultValue={this.props.project.information.problem}
            floatingLabelText="Problema u oportunidad"
            floatingLabelFixed={true}
            fullWidth={true}
            rows={3}
            rowsMax={5}
            multiLine={true}
            onChange={(event, newValue) => this.handleChange(event, newValue, "problem")}
            disabled={isFinished || this.props.project.information.leader_email !== this.props.user.email}
          />
          <TextField
            underlineStyle={styles.underline}
            floatingLabelStyle={styles.floatingLabel}
            textareaStyle={styles.textArea}
            inputStyle={{...styles.latoFont, ...{marginLeft: '1em'}}}
            defaultValue={this.props.project.information.solution}
            floatingLabelText="Descripción de la solución"
            floatingLabelFixed={true}
            fullWidth={true}
            rows={3}
            rowsMax={5}
            multiLine={true}
            onChange={(event, newValue) => this.handleChange(event, newValue, "solution")}
            disabled={isFinished || this.props.project.information.leader_email !== this.props.user.email}
          />
          <TextField
            underlineStyle={styles.underline}
            floatingLabelStyle={styles.floatingLabel}
            textareaStyle={styles.textArea}
            inputStyle={{...styles.latoFont, ...{marginLeft: '1em'}}}
            defaultValue={this.props.project.information.objectives}
            floatingLabelText="Objetivos de la solución"
            floatingLabelFixed={true}
            fullWidth={true}
            rows={3}
            rowsMax={5}
            multiLine={true}
            onChange={(event, newValue) => this.handleChange(event, newValue, "objectives")}
            disabled={isFinished || this.props.project.information.leader_email !== this.props.user.email}
          />
          <TextField
            underlineStyle={styles.underline}
            floatingLabelStyle={styles.floatingLabel}
            textareaStyle={styles.textArea}
            inputStyle={{...styles.latoFont, ...{marginLeft: '1em'}}}
            defaultValue={this.props.project.information.characteristics}
            floatingLabelText="Características de la solución"
            floatingLabelFixed={true}
            fullWidth={true}
            rows={3}
            rowsMax={5}
            multiLine={true}
            onChange={(event, newValue) => this.handleChange(event, newValue, "characteristics")}
            disabled={isFinished || this.props.project.information.leader_email !== this.props.user.email}
          />
          <TextField
            underlineStyle={styles.underline}
            floatingLabelStyle={styles.floatingLabel}
            textareaStyle={styles.textArea}
            inputStyle={{...styles.latoFont, ...{marginLeft: '1em'}}}
            defaultValue={this.props.project.information.benefits}
            floatingLabelText="Beneficios"
            floatingLabelFixed={true}
            fullWidth={true}
            rows={3}
            rowsMax={5}
            multiLine={true}
            onChange={(event, newValue) => this.handleChange(event, newValue, "benefits")}
            disabled={isFinished || this.props.project.information.leader_email !== this.props.user.email}
          />
      </div>
      <h2>2. Cálculo del proyecto </h2>
      <h3>2.1 Resultados</h3>
      <p>Ingresa aquí el valor generado por tu proyecto correspondiente a los siguientes años</p>
        <IndicatorField
          onChange={(event, newValue, type) => this.handleChange(event, newValue, type)}
          token={this.props.token}
          indicator={this.props.user.indicator}
          currency={this.props.user.currency}
          projectId={this.props.project.id}
          disabled={this.props.project.information.leader_email !== this.props.user.email || isFinished}/>
        <h3>2.2 Método de cálculo (pdf)</h3>
        <FileField
          disabled={isFinished || this.props.project.information.leader_email !== this.props.user.email}
          projectLeader={this.props.project.information.leader_email === this.props.user.email}
          userPosition={this.props.user.position}
          projectId={this.state.id} token={this.props.token}
          downloadedFileName={"Método-proyecto-" + this.props.project.information.name}
          uploadType='method'
          currentFileName={this.props.project.method_file_name} />

        <h3>2.3 Hoja de cálculo (xlsx o xls)</h3>
        <FileField
          disabled={isFinished || this.props.project.information.leader_email !== this.props.user.email}
          projectLeader={this.props.project.information.leader_email === this.props.user.email}
          userPosition={this.props.user.position}
          projectId={this.state.id} token={this.props.token}
          downloadedFileName={"Cálculo-proyecto-" + this.props.project.information.name}
          uploadType='calculation'
          currentFileName={this.props.project.calculation_file_name} />
    </div>
    )
  }

  DatetoYYYYMMDD = (date) => {
    var mm = date.getMonth() + 1; // getMonth() is zero-based
    var dd = date.getDate();

    return [date.getFullYear(),
            (mm>9 ? '' : '0') + mm,
            (dd>9 ? '' : '0') + dd
          ].join('-');
  };

  handleChange = (event, newValue, type) => {
    this.props.handleInformationChange(type, newValue);
    this.setState({[type]: newValue});
  };
}

export default withCookies(withRouter(ProjectInformation));



// WEBPACK FOOTER //
// ./src/components/files/ProjectInformation.js